import React from 'react'
import { Box, Typography, Button, Hidden } from '@mui/material'
import { Navbar } from '../component/shared/Navbar'
import { UserTable } from '../component/admin/UserTable'
import { Helmet } from 'react-helmet-async'
import { AdminMenu } from '../component/admin/AdminMenu'
import { AdminXsMenu } from '../component/admin/AdminXsMenu'

export const AdminPanelScreen = () => {
  return (
    <>
      <Helmet titleTemplate='%s | Staff Portal' defaultTitle='Staff Portal'>
        <title>Admin</title>
      </Helmet>

      <Navbar />
      <Box display={{ xs: 'block', md: 'flex' }}>
        <AdminMenu />
        <Box overflow='hidden' width='100%' sx={{ p: { xs: 1 } }} mb={{ xs: 2, md: 10 }}>
          <Box display='flex' my={3} justifyContent='space-between'>
            <Typography variant='h1'>Users</Typography>
            <AdminXsMenu />
            <Hidden mdDown>
              <Button component='a' href='/create-user' variant='contained' color='primary'>
                Create New User
              </Button>
            </Hidden>
          </Box>

          <Hidden mdUp>
            <Box mb={2}>
              <Button component='a' href='/create-user' variant='contained' color='primary'>
                Create New User
              </Button>
            </Box>
          </Hidden>

          <UserTable />
        </Box>
      </Box>
    </>
  )
}
